// extracted by mini-css-extract-plugin
export default {"surveyBackDrop":"TaskSurvey_surveyBackDrop__Ig0rX","surveyBackDropActive":"TaskSurvey_surveyBackDropActive__nlPPE"};